import React from 'react';
import { IconButton, Stack, Typography } from '@mui/material';
import { StackProps } from '@mui/material/Stack/Stack';
import { CrossIcon } from 'assets';

import styles from './ModalTitle.module.scss';

export interface ModalTitleProps extends StackProps {
  title: string;
  notTransformToUpper?: boolean;
  onClose?: () => void;
  rightContent?: React.ReactNode;
}

export function ModalTitle({ title, onClose, notTransformToUpper, rightContent, ...rest }: ModalTitleProps) {
  return (
    <Stack direction='row' alignItems='center' justifyContent='space-between' {...rest}>
      <Stack direction='row' alignItems='center' gap={1.2}>
        <Typography
          component='p'
          variant='body2'
          align='center'
          textTransform={notTransformToUpper ? 'none' : 'uppercase'}
          fontWeight={700}
        >
          {title}
        </Typography>
        {rightContent}
      </Stack>

      {onClose && (
        <IconButton
          onClick={onClose}
          sx={{ paddingTop: 0, paddingBottom: 0, '&:hover': { backgroundColor: 'transparent' } }}
          edge='end'
          disableRipple
        >
          <CrossIcon color='primary' className={styles.cross} sx={{ fontSize: '1.3rem' }} />
        </IconButton>
      )}
    </Stack>
  );
}
